import { forwardRef, type HTMLAttributes } from 'react';
import { cn, badgeVariants, type BadgeVariants } from '../../../utils';

export interface BadgeProps extends HTMLAttributes<HTMLSpanElement>, BadgeVariants {}

export const Badge = forwardRef<HTMLSpanElement, BadgeProps>(
  ({ className, variant, size, shape, ...props }, ref) => (
    <span ref={ref} className={cn(badgeVariants({ variant, size, shape }), className)} {...props} />
  )
);
Badge.displayName = 'Badge';
